import { render } from "./CrossStep1Completato.vue?vue&type=template&id=8a860cc6"
import script from "./CrossStep1Completato.vue?vue&type=script&lang=js"
export * from "./CrossStep1Completato.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__